import { Context } from "@nuxt/types/app";
import { defineNuxtPlugin } from "@nuxtjs/composition-api";

import { employeeBenefitPlugin } from "./employee-benefit.plugin";

export default defineNuxtPlugin((context: Context, inject): void => {
  inject("eb", employeeBenefitPlugin(context));
});
